import React, { useEffect, useState } from 'react';
import { PlusCircleIcon } from '@heroicons/react/20/solid';

import { Button } from '../../../components/Button';
import SelectContacts from '../../../components/SelectContacts';
import Modal from '../../../components/Shell/Modal';
import useAsync from '../../../hooks/useAsync';
import { addAssetContacts, removeAssetContact } from '../../../api';
import useModal from '../../../hooks/useModal';
import DataTable from '../../../components/DataTable';

import { UsersIcon } from '@heroicons/react/24/outline';

export default ({ item, refresh, bare }) => {
	const {
		open,
		setOpen,
		setClose: onCloseDeleteModal,
	} = useModal('deleteModal');
	const { setOpen: onViewContact } = useModal('viewContact');
	const [vendorToAdd, setVendorToAdd] = useState(null);
	const [vendors, setVendors] = useState(null);
	const [openAddVendorModal, setOpenAddVendorModal] = useState(false);

	const { execute: onAddContacts, status } = useAsync(addAssetContacts, {
		immediate: false,
	});
	const { execute: onRemoveContact } = useAsync(removeAssetContact, {
		immediate: false,
	});

	useEffect(() => {
		if (item) {
			setVendors(item?.contacts);
		}
	}, [item]);

	return (
		<>
			<div className="block sm:hidden">
				{/*<h2 className="flex sm:items-baseline flex-col sm:flex-row text-base/7 font-semibold text-zinc-950 sm:text-sm/6 mr-4">
								Documents
							</h2>
			
							<div className="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
								<dd className="mt-2 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
									<ul
										role="list"
										className="divide-y divide-gray-100 rounded-md border border-gray-200"
									>
										<li className="flex items-center justify-between py-4 pr-5 pl-4 text-sm/6">
											<div className="flex w-0 flex-1 items-center">
												<PaperClipIcon
													aria-hidden="true"
													className="size-5 shrink-0 text-gray-400"
												/>
												<div className="ml-4 flex min-w-0 flex-1 gap-2">
													<div>
														<div className="truncate font-medium text-gray-900">
															resume_back_end_developer.pdf
														</div>
														<div className="shrink-0 text-gray-400">2.4mb</div>
													</div>
												</div>
											</div>
										</li>
									</ul>
								</dd>
							</div>*/}
			</div>
			<div className="hidden sm:block grid grid-cols-12 py-4">
				<div className="flex items-center justify-between">
					<div className=" text-lg font-semibold">
						<span className="block sm:hidden">Vendors</span>
					</div>
					<div className="flex items-center">
						{/*<Button type="secondary">Add Existing Document</Button>*/}
						<Button
							Icon={UsersIcon}
							onClick={() => {
								setOpenAddVendorModal(true);
							}}
						>
							Add Vendor
						</Button>
					</div>
				</div>

				<div className="mt-6">
					<DataTable
						data={{ rows: vendors || [] }}
						columns={[
							{
								header: 'Name',
								accessorKey: 'firstName',
								cell: (info) => {
									const row = info?.row?.original;
									return row?.type === 'person'
										? `${row.firstName} ${row.lastName}`
										: row.companyName;
								},
							},
							{
								header: 'Type',
								accessorKey: 'companyName',
								cell: (info) => {
									const row = info?.row?.original;
									return row?.type === 'person' ? 'Person' : 'Company';
								},
							},
							{
								header: 'Title',
								accessorKey: 'companyName',
								cell: (info) => {
									const row = info?.row?.original;
									return row.type === 'person'
										? `${row.title || ''}${
												row.companyName ? ` at ${row.companyName}` : ''
											}`
										: '';
								},
							},
							{
								header: 'Email',
								accessorKey: 'lastName',
								cell: (info) => {
									const row = info?.row?.original;
									return row?.email;
								},
							},
						]}
						onRow={(row) => onViewContact({ id: row?.original?.id })}
						rowActions={[
							{
								name: 'Remove',
								onClick: (row) => {
									const person = row?.original;
									setOpen({
										title: `Remove ${
											person.type === 'person'
												? `${person.firstName}`
												: person.companyName
										} from this instrument`,
										confirmText: 'Remove',
										onConfirm: () =>
											onRemoveContact(
												{ id: item?.id, contacts: [person.id] },
												() => {
													onCloseDeleteModal();
													refresh({ id: item?.id }, null, {
														silent: true,
													});
												},
												{ silent: true },
											),
									});
								},
							},
						]}
						usePagination={false}
						useExport={false}
						useSearch={false}
						hasCheckboxes={false}
						disableTitle
					/>
				</div>
			</div>
			<Modal
				open={openAddVendorModal}
				title={'Add Vendor to Asset'}
				onClose={() => setOpenAddVendorModal(false)}
			>
				<SelectContacts
					onChange={(value) => setVendorToAdd(value)}
					value={vendorToAdd?.id}
					skip={vendors?.map((vendor) => vendor.id) || []}
				/>

				<div className="flex justify-end mt-3">
					<Button
						onClick={() => {
							onAddContacts(
								{
									id: item?.id,
									contacts: [vendorToAdd?.id],
								},
								() => {
									setOpenAddVendorModal(false);
									setVendorToAdd(null);
									refresh({ id: item?.id }, null, { silent: true });
								},
							);
						}}
						disabled={!vendorToAdd}
					>
						{status === 'pending' ? 'Adding...' : 'Add'}
					</Button>
				</div>
			</Modal>
		</>
	);
};
